import * as Dialog from "@radix-ui/react-dialog"
import styled from "styled-components"
import globalStyles from "@data/style.globals"
import StyledButton from "@components/buttons/StyledButton"
import useStore from "@state/store"
import { useSyncStatesWithSocket } from "@utils/useSyncStatesWithSockets"
import roomMapper from "@data/roomToNav.map.json"
import { Room } from "@providers/sockets/SocketIOProvider"

export default function TakeoverExitWarning() {
  const showTakeoverExitWarning = useStore((s) => s.showTakeoverExitWarning)
  const attemptedRoom = useStore((s) => s.attemptedRoom) as Room | null
  const { syncStatesWithSocket: syncState } = useSyncStatesWithSocket()

  const handleReconnect = () => {
    syncState({ showTakeoverExitWarning: false })

    setTimeout(() => {
      syncState({
        showMenu: true,
        attemptedRoom: null,
        roomTakenOver: null,
      })
    }, 100)
  }

  const handleClose = () => {
    syncState({
      showTakeoverExitWarning: false,
      attemptedRoom: null,
    })
  }

  return (
    <DialogRoot open={showTakeoverExitWarning}>
      <DialogContent>
        <PopupMessage>
          Connection lost. You are no longer in takeover mode.
        </PopupMessage>
        <PopupSection>
          {["RECONNECT", "CLOSE"].map((label, index) => (
            <StyledButton
              background="#000"
              style={{
                width: "100%",
                height: "100%",
                fontSize: "2rem",
              }}
              key={index}
              onClick={() => {
                if (label === "RECONNECT") {
                  handleReconnect()
                } else {
                  handleClose()
                }
              }}
            >
              <h3>{label}</h3>
            </StyledButton>
          ))}
        </PopupSection>
      </DialogContent>
    </DialogRoot>
  )
}

const DialogRoot = styled(Dialog.Root)`
  z-index: 999999;
  /* position: fixed; */

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: all;
  background-color: rgba(255, 255, 255, 0.95);
  font-family: "Stolzl";
  overflow: hidden;
`

const DialogContent = styled(Dialog.Content)`
  position: fixed;
  /* top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  display: grid;
  place-items: center;
  grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
  grid-auto-flow: row;
  pointer-events: all;
  background-color: ${globalStyles.colors.white};
`

const PopupMessage = styled.div`
  font-size: 2.4rem;
  text-align: center;
  padding: 2rem;
  background-color: ${globalStyles.colors.white};
  z-index: 999999;
`

const PopupSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 2rem;
  width: 100%;
  max-width: 600px;
  min-height: 10rem;
  pointer-events: all;
  z-index: 999999;
  background-color: ${globalStyles.colors.white};
`
